import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zAttributeSum = z.object({
  attributeId: zUid,
  sum: z.number(),
});
export type ZAttributeSum = z.infer<typeof zAttributeSum>;

export const enum ChildEntsActionType {
  changeState = "changeState",
  copyIn = "copyIn",
  copyFrom = "copyFrom",
  select = "select",
  rowClick = "rowClick",
}
